import React from "react";

import { numberWithCommas, isEmpty } from "lib/utils";
import * as C from "../../constants";
import { useLocalStorage } from "../../lib/useLocalStorage";

const BuyInput = ({
  buyPoint,
  estimateTrade,
  handleClickMaxPoint,
  handleChangeBuyPoint,
  buyPointSearch,
}) => {
  const [serviceCode] = useLocalStorage(C.STORAGE_KEY.SERVICE_CODE);
  const display = C.Message.display[serviceCode];
  return (
    <>
      <div className="tit_wrap">
        <h3 className="mtit">매수 {display.amount}</h3>
        <span className="ex_tt" onClick={handleClickMaxPoint}>
          최대사용
        </span>
      </div>
      <div className="input_box">
        <input
          type="text"
          value={numberWithCommas(buyPoint)}
          placeholder={`${numberWithCommas(display.minAmount)} ${
            display.unit
          }부터 사용가능합니다`}
          onChange={handleChangeBuyPoint}
          pattern="[0-9]*"
          inputMode="numeric"
        />
        <span className="right">{display.unit}</span>
      </div>
      <p className="noti_tt">
        <span className="noti_red"> &nbsp; &nbsp; </span>수수료를 포함한
        금액입니다.
      </p>
      <div className="btn_area apply_btn MT20">
        <div className="bt_col1">
          <input
            type="button"
            value={!isEmpty(estimateTrade) ? "다시 조회" : "조회"}
            className="blue"
            onClick={buyPointSearch}
            disabled={buyPoint.length === 0}
          />
        </div>
      </div>
    </>
  );
};

export default BuyInput;
